import React, {useEffect} from 'react';
import { Breadcrumb, BreadcrumbItem } from 'reactstrap';
import {Link} from "react-router-dom";
import {Helmet} from "react-helmet";
import CssBaseline from "@material-ui/core/CssBaseline";
import Container from "@material-ui/core/Container";
import { Typography } from '@mui/material';
import Diversity1Icon from '@mui/icons-material/Diversity1';
import Divider from '@material-ui/core/Divider';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';
import CardMedia from '@material-ui/core/CardMedia';
import Box from '@mui/material/Box';
import {makeStyles} from "@material-ui/core/styles";
import wallPaper from "../assets/static/images/lob-about-cover.jpg";
import lobFront from "../assets/static/images/lob-lodge-front.jpeg";
import {data, ourTeamImages} from "./configs/AboutData";
import {ourTeam, ourValues} from "./configs/HomeData";
import MetaHead from "../shared/MetaHead";



const useStyles = makeStyles((theme) => ({
  heroContent: {
    padding: theme.spacing(14, 0, 9),
    backgroundImage: `url(${wallPaper})`,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    backgroundBlendMode: 'darken',
    backgroundSize: 'cover'
  },
  sections: {
  },
  sectionTitles: {
    paddingBottom: '30px',
    fontWeight: 'bolder',
    paddingTop: '64px',
  },
  coreValues: {
    fontWeight: 'bold'
  }
}));


export default function About(props) {

  const classes = useStyles();

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
  <React.Fragment>
    <MetaHead/>
    <CssBaseline />
    <main>
    {/* Hero unit */}
    <div className={classes.heroContent}>
    <Breadcrumb>
      <BreadcrumbItem><Link to="/">Home</Link></BreadcrumbItem>
      <BreadcrumbItem active>About</BreadcrumbItem>
    </Breadcrumb>
      <Container maxWidth="sm">
        <Typography
          component="h1"
          variant="h4"
          align="center"
          color="textPrimary"
          style={{fontWeight: 'bold', color: 'white'}}
          gutterBottom>
          <span className="page-header">About</span>
        </Typography>
      </Container>
    </div>
    </main>
    <div>
      {/*Welcome*/}
      <div className={classes.sections}>
        <Container maxWidth="md">
          <Typography
          component="h1"
          variant="h4"
          align="center"
          className={classes.sectionTitles}
          gutterBottom>
            Welcome to Pudsey Lodge of Benevelonce 5612
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={4} md={4}>
              <Card elevation={0} sx={{ borderRadius: 2, overflow: 'hidden', boxShadow: 2 }}>
                <CardMedia component="img" image={lobFront} alt="Pudsey Masonic Hall" />
              </Card>
            </Grid>
            <Grid item xs={12} sm={8} md={8}>
              <Typography>
                {data.whoWeAre}
              </Typography>
            </Grid>
          </Grid>

        </Container>
      </div>

      {/*Our Members*/}
      <div className={classes.sections}>
        <Container maxWidth="md">
          <Typography
            component="h1"
            variant="h4"
            align="center"
            className={classes.sectionTitles}
            gutterBottom>
              Our Members
          </Typography>
          <Grid container spacing={4}>
            {ourTeamImages.map((card) => (
              <Grid item key={card.id} xs={12} sm={4} md={4} style={{ display: 'flex' }}>
                <Card className={classes.card} elevation={0} style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
                  {/*icon implementation*/}
                  {/*<div style={{ textAlign: 'center', marginTop: '20px' }}>*/}
                  {/*  {card.icon}*/}
                  {/*</div>*/}

                  {/* Image instead of icon */}
                  <div style={{ textAlign: 'center', marginTop: 20 }}>
                    <Box
                      component="img"
                      src={card.img}
                      alt={card.imgAlt || card.title}
                      loading="lazy"
                      sx={{
                        width: 150,
                        height: 150,
                        borderRadius: '50%',
                        objectFit: 'cover',
                        boxShadow: 3,
                      }}
                    />
                  </div>

                  <CardContent className={classes.cardContent} style={{ flexGrow: 1 }}>
                    <Typography
                      gutterBottom
                      variant="h6"
                      component="h2"
                      style={{ fontWeight: 'bold', textAlign: 'center' }}>
                      {card.title}
                    </Typography>
                    {/*<Divider variant="middle" style={{ marginBottom: '15px', marginTop: '15px' }} />*/}
                    <Typography style={{ textAlign: 'left', color: '#686868' }}>
                      {card.desc}
                    </Typography>
                  </CardContent>
                  <CardActions style={{ marginBottom: '20px', alignItems: 'center', justifyContent: 'center' }}>
                  </CardActions>
                </Card>
              </Grid>
            ))}

          </Grid>
        </Container>
      </div>

      {/*Our Values*/}
      <div className={classes.sections} style={{display: 'none'}}>
        <Container maxWidth="md">
          <Typography
          component="h1"
          variant="h4"
          align="center"
          className={classes.sectionTitles}
          gutterBottom>
            Our Values
          </Typography>
          <Grid container spacing={4}>
            {ourValues.map((card) => (
              <Grid item key={card.id} xs={12} sm={4} md={4} style={{ display: 'flex' }}>
                <Card className={classes.card} elevation={0} style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
                  <div style={{ textAlign: 'center', marginTop: '20px' }}>
                    {card.icon}
                  </div>
                  <CardContent className={classes.cardContent} style={{ flexGrow: 1 }}>
                    <Typography
                      gutterBottom
                      variant="h6"
                      component="h2"
                      style={{ fontWeight: 'bold', textAlign: 'center' }}>
                      {card.title}
                    </Typography>
                    {/*<Divider variant="middle" style={{ marginBottom: '15px', marginTop: '15px' }} />*/}
                    <Typography style={{ textAlign: 'center', color: '#686868' }}>
                      {card.desc}
                    </Typography>
                  </CardContent>
                  <CardActions style={{ marginBottom: '20px', alignItems: 'center', justifyContent: 'center' }}>
                  </CardActions>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Container>
      </div>

      {/*Mission Statement*/}
      <div className={classes.sections} style={{display: 'none'}} >
        <Container maxWidth="md">
          <Typography
            component="h1"
            variant="h4"
            align="center"
            className={classes.sectionTitles}
            gutterBottom>
            Mission Statement
          </Typography>
          <Typography>
            {data.missionStatement}
          </Typography>
          <br/><br/><br/>

        </Container>

      </div >

    </div>
  </React.Fragment>
  );
}